module.exports = require("core-js-pure/stable/instance/starts-with");